import { Component } from '@angular/core';

@Component({
  selector: 'app-appless',
  imports: [],
  templateUrl: './appless.html',
  host: { class: 'block h-full min-h-0 w-full min-w-0 p-4' },
  styleUrl: './appless.css',
})
export class Appless {

}
